const storeSession = (_, { currentUser } , { cache }) => {
  cache.writeData({
    data: {
      session: {...currentUser, __typename: 'AuthPayload'}
    }
  });
  return currentUser;
};

export default {
  Mutation: {
    storeSession
  }
}
